import { makeStyles, shorthands } from "@fluentui/react-components";

const useStatusBarStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",
    color: "#FFFFFF",
    justifyContent: "space-between",
    ...shorthands.padding("4px", "8px"),
    backgroundColor: "#394146",
  },

  activeStatusColor: {
    backgroundColor: "#359B35",
  },

  status: {
    display: "flex",
    alignItems: "center",
    height: "fit-content",
    ...shorthands.gap("4px"),
  },

  statusText: {
    marginTop: "0",
    marginBottom: "0",
  },
});

export default useStatusBarStyles;
